import React from 'react';
import styles from './number-circle.module.css';

const NumberCircle = props => {
  return (
    <div className={ `${styles.stylish} ${props.inactive ? styles.inactive : ""}` }><p>{ props.children }</p></div>
  );
}

export default NumberCircle;